import { useQuery } from '@tanstack/react-query'
import { claims, isKeycloakConfigured } from '../auth/keycloak'
import { api } from './client'
import type { MeResponse } from './types'

/** Who the API thinks the caller is. Keyed by subject so a re-login never serves a stale user. */
export function useMe() {
  const subject = isKeycloakConfigured() ? (claims().sub ?? 'unknown') : 'stub'

  return useQuery({
    queryKey: ['me', subject],
    queryFn: () => api.get<MeResponse>('/api/me'),
    staleTime: 60_000,
    retry: 1,
  })
}
